import { render, staticRenderFns } from "./WelcomeExOi.vue?vue&type=template&id=a97e51d2&scoped=true"
import script from "./WelcomeExOi.vue?vue&type=script&lang=js"
export * from "./WelcomeExOi.vue?vue&type=script&lang=js"
import style0 from "./WelcomeExOi.vue?vue&type=style&index=0&id=a97e51d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97e51d2",
  null
  
)

export default component.exports